<template>
  <div>
    <div class="row col-md-12">
      <div class="col-md-3 col-md-push-9">
        <h1 style="margin-bottom:10px;">{{ $t('pesquisa') | capitalize }}</h1>
        <input type="text" class="form-control" :placeholder="$t('placeholder_pesquise_por_nome')" v-model="pesquisa">
      </div>

      <div class="col-md-9 col-md-pull-3">
        <div>
          <h1>{{ $tc('autor', 2) }} <small>({{autores_pesquisa.length}}/{{autores.length}})</small></h1>
          <div class="letra-parent" style="margin-top:10px; margin-bottom:20px;" v-if="pesquisa === ''">
            <div class="letra" :class="{'letra-selected': letra == l}" v-for="l in letras" @click="letra = l">
              {{l | upper}}
            </div>
          </div>
        </div>

        <!-- lista de pessoas -->
        <div>
          <div v-if="autores_pesquisa.length === 0">
            <span v-if="pesquisa !== '' || !letra">{{ $t('nenhuma_pessoa_encontrada') }}</span>
            <span v-else>{{ $t('nenhuma_pessoa_encontrada_com_letra', { letra: letra.toUpperCase() }) }}</span>
          </div>
          <div v-else>
            <router-link class="a" :to="'/autor/' + a.id" v-for="a in autores_pesquisa" :key="a.id">
              <div class="a-nome" style="line-height: 100%; font-size: 25px;">{{a.nome}}</div>
              <div class="a-instituicao">{{a.instituicao}}</div>
              <div class="a-infos">
                <div class="a-info">
                  <b>{{a.todos_trabalhos.length}}</b>
                  {{ $tc('publicacao', a.todos_trabalhos.length) }}
                </div>
                <div class="a-info"><b>{{a.eixos.length}}</b> {{ $tc('eixo_tematico', a.eixos.length) }}</div>
              </div>
            </router-link>
          </div>
        </div>
        <!-- fim da lista de pessoas -->
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import removeAccents from 'remove-accents'
import { i18n } from '@/langs/anais'

export default {
  name: 'anaisAutores',
  props: {},
  components: {},
  data () {
    return {
      // a letra atual
      // se termina com _
      // é pq tem um computed
      letra: null,
      // todas as letras do alfabeto
      letras: [
        'a', 'b', 'c', 'd', 'e',
        'f', 'g', 'h', 'i', 'j',
        'k', 'l', 'm', 'n', 'o',
        'p', 'q', 'r', 's', 't',
        'u', 'v', 'w', 'x', 'y', 'z'
      ],
      // cada autor por letra
      autores_letra: {},
      // o que estou pesquisando
      pesquisa: '',
    }
  },
  filters: {},
  watch: {
    '$route.params.pesquisa'() {
      this.changePesquisaFromParam()
    }
  },
  computed: {
    autores_pesquisa() {
      if(this.pesquisa != '') {
        // se na string str
        // contem o this.pesquisa
        // retorna true
        let pesquisa = removeAccents(this.pesquisa.toLowerCase())
        let find = (str) => removeAccents(str.toString().toLowerCase()).indexOf(pesquisa) != -1
        return this.autores.filter(a => {
          // vamos verificar se esse autor
          // tem alguma coisa em comum
          // com a pesquisa
          let possiveisStrs = [
            a.nome, a.instituicao
          ]

          // retorna true se alguma das possiveis strings
          // conter a pesquisa
          for(let i=0; i<possiveisStrs.length; i++) {
            let str = possiveisStrs[i];
            if(find(str)) {
              return true
            }
          }
          // nao encontrei
          return false
        })
      }

      // se não tem pesquisa
      // só retorna o cara da letra
      return this.autores_letra[this.letra]
    },

    // eu preciso fazer um computed
    // pq eu qro acessar essas variáveis diretamente do <template>
    eixos() { return eixos }, autores() { return autores }, palavras_chaves() { return palavras_chaves }, trabalhos() { return trabalhos },
  },
  created: function () {
    // defino o autores_letra
    // primeiro, defino os arrays
    this.letras.forEach(l => {
      this.autores_letra[l] = []
    })
    // agora preencho
    this.autores.forEach(a => {
      // na página de autores
      // preciso de algumas estatísticas

      // a letra L
      let l = a.id[0]
      this.autores_letra[l].push(a)
    })

    // agora eu mudo a letra
    this.letra = 'a'

    this.changePesquisaFromParam()
  },
  mounted: function () {},
  methods: {
    changePesquisaFromParam() {
      let pesquisa = this.$route.params.pesquisa
      if(pesquisa) {
        this.pesquisa = pesquisa
      }
    }
  },
  i18n: i18n
}
</script>

<style type="text/css" scoped>
.letra {
  cursor: pointer;
  width: 3.84%;
  text-align: center;
  display: inline-block;
  color: #333;
  font-size: 32px;
  font-family: monospace;
}
.letra:hover {
  font-weight: bold;
}
.letra-selected {
  text-decoration: underline;
}


/* A é autor
mas é o autor da lista de autores*/
a.a {
  color: unset;
}
a.a:hover {
  text-decoration: unset;
  color: unset;
}
.a {
  padding: 0 10px;
  margin: 40px 0;
  border: 1px solid darkred;
  border-top: 0;
  border-left: 0;
  cursor: pointer;
  display: block;
}
.a:hover {
  box-shadow: 0px 0px 8px #CCC;
}
.a-nome {
  font-size: 32px;
  padding: 10px 0;
  color: black;
}
.a:hover .a-nome {
  text-decoration: underline;
}
.a-infos {
  border-top: 1px solid #CCC;
}
.a-info {
  display: inline-block;
  margin: 10px;
  margin-left: 0;
}
</style>


// WEBPACK FOOTER //
// AnaisAutores.vue?92b9b4d8